import { defineMessages } from 'react-intl';

export default defineMessages({ 
    startpagecancelChangeTitle:{
        "id":"CPMIpayrollreporting.requestchange.Cancel payroll reporting update",
        "defaultMessage":"Cancel payroll reporting update"
    },
    startpagecancelChangeMessage:{
        "id":"CPMIpayrollreporting.requestchange.Are you sure you want to cancel your payroll reporting changes?",
        "defaultMessage":"Are you sure you want to cancel your payroll reporting changes?"
    },
    submitTitle:{
        "id":"CPMIpayrollreporting.requestchange.Certify Payroll",
        "defaultMessage":"Certify Payroll"
    },
    draftErrorMessage:{
        "id":"CPMIpayrollreporting.requestchange.We are currently unable to access your data. Please contact us at 1.800.231.1363 so that we can assist.",
        "defaultMessage":"We are currently unable to access your data. Please contact us at 1.800.231.1363 so that we can assist."
    },
    submitMessage:{
        "id":"CPMIpayrollreporting.requestchange.AI certify that payroll figures appearing in this report are true and a complete statement of all the earnings by all of our employees for the period stated.",
        "defaultMessage":"I certify that payroll figures appearing in this report are true and a complete statement of all the earnings by all of our employees for the period stated."
    },

});